:host {
  &[disabled]:not([disabled="false"]) {
    --description-color: #{$formDisabledColor};
  }
  &[active]:not([active="false"]) {
    --background-color: var(
      --stzh-chip-active-background-color,
      #{$colorPrimary70}
    );
  }
  &[active].is-focused {
    --background-color: var(
      --stzh-chip-active-background-color,
      #{$colorPrimary70}
    );
  }
}

.stzh-chipselect {
  @include input-description;

  &__label {
    @include font("heavy");
    @include fontSize("micro");
    @include truncate;
    color: $headingColor;
    display: block;
    margin-bottom: space("xsmall");

    &:empty {
      display: none;
    }
  }

  &__marker {
    @include fontSize("nano");
    margin-left: calc(-0.25em + #{space("xsmall")});
  }

  &__chips {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    border-radius: $buttonBorderRadius;
    gap: space("medium");

    &:focus-within {
      .is-focused[active] {
        --background-color: #{$colorPrimary90};

        @include highContrast() {
          --background-color: Canvas;
        }
      }
    }
  }

  &__chip {
    &.is-focused:not([active]) {
      --background-color: #{$colorSecondary40};

      @include highContrast() {
        --background-color: Highlight;
      }
    }
  }

  // &__dropdown {
  //   @include mq($from: medium) {
  //     display: none;
  //   }
  // }

  // &__description-wrapper {
  //   @include mq($to: medium) {
  //     display: none;
  //   }
  // }

  &--has-error &__error,
  &--has-description &__description {
    margin-top: space("xsmall");
  }

  /* Hidden label */

  &--has-label-hidden &__label {
    @include visuallyhidden;
  }

  /* Disabled */

  &--is-disabled &__chips,
  &--is-disabled &__label {
    cursor: not-allowed;
  }
}
